// extracted by mini-css-extract-plugin
export default {"hide":"styles_hide__GAzfn","greyed-out":"styles_greyed-out__HyEEw","tagTitle":"styles_tagTitle__rSEoS","sectionHeader":"styles_sectionHeader__DfJF7"};